module.exports = __webpack_public_path__ + "img/6.d59ec311.jpg";